module.exports = __webpack_public_path__ + "images/emoji/custard.2cc9716991e1ba681ee3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/custard.png
// module id = T82D
// module chunks = 1